<template>
    <form ref="form">
        <div v-if="!showStart" class="progress mb-3" style="height: 8px;">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: stepProgress + '%'}"></div>
        </div>
        <transition name="shake">
            <div v-if="message" class="rounded bg-info text-center text-white px-3 py-3 my-3">
            {{ message }}
        </div>
        </transition>
        <div v-if="showStart">
            <div class="form-group">
                <h3 class="text-left text-4">Get your 3rd Party Cover, ZINARA, and ZBC for your car in a Few Simple Steps!</h3>
                <hr>
                <div class="row d-flex flex-row align-items-center">
                    <div class="col-2 text-left text-5 ">
                        <img class="rounded-lg mobile-ad" src="/img/providers/delivery.svg" width="50" alt="">
                    </div>
                    <h5 class="col-10 text-left font-weight-500 text-2 ">
                        Enjoy <b class="bg-info text-white px-1">FREE DELIVERY IN HARARE</b> when you insure your vehicle on Magetsi. Collection option is also available.
                    </h5>

                </div>
                <hr>
                <p class="text-1">
                    Magetsi offers vehicle insurance and licensing services through our trusted partners, Moovah and ZINARA.
                    To purchase a vehicle license, you must buy a minimum of 4 months of insurance coverage from Moovah.
                    Currently, we offer RTA [3rd Party Cover] and [Mandatory Cover required by Zimbabwe's Road Traffic Act].
                    Comprehensive cover options are not available at this time due to transaction limits.
                </p>
            </div>
            <hr>
            <div class="row d-flex align-items-center">
                <h5 class="col-1 text-left text-5 ">
                      ⚠️
                </h5>
                <h5 class="col-11 text-left font-weight-500 text-2 ">
                    Please note: This product is only available in ZWG and payable only via EcoCash.
                </h5>

            </div>
            <hr>
            <p class="text-1">
                Check your registration, buy insurance and vehicle license together – all in one place!
            </p>
            <div   class="text-center mt-3">

                <button type="button"
                        :class="['btn btn-block btn-primary px-4']"
                        @click="toggleShowStart">
                    Start Here - Check Registration Status
                </button>
            </div>

        </div>

        <transition name="slide-in-left">
            <div v-if="showStart === false">
                <div>
                    <h5 class="text-left font-weight-500 text-2">
                        Step 1: Check Your Moovah Registration Status
                    </h5>
                    <p class="text-1">
                        Enter your mobile number to check if you are registered with Moovah.
                    </p>
                    <div class="form-group">
                        <label>Econet Phone Number</label>
                        <phone-input v-model="form.phone" :countries="['ZW']"></phone-input>
                        <div v-text="form.errors.get('phone')" class="text-danger"/>
                    </div>
                    <div v-if="form.errors.get('phone')"  class="text-center my-3">
                        <router-link to="/zinara/buy"
                                     :class="['btn btn-block btn-primary px-4']"
                        >
                            Purchase Insurance and Vehicle License Now!
                        </router-link>
                    </div>
                    <p class="text-1">
                        If you are not registered, you will be prompted to register before proceeding.
                    </p>
                    <div v-if="!verified">
                        <div v-if="otp" class="form-group">
                            <label>OTP (One time password)</label>
                            <input type="number" :class="[ 'form-control' , form.errors.get('otp') ? 'is-invalid rounded-top' : '' ]"
                                   v-model="form.otp"/>
                            <div v-text="form.errors.get('otp')" class="bg-danger rounded-bottom text-white text-center text-1 mb-1"/>
                        </div>

                        <div v-if="!otp" class="text-center mt-3">
                            <button type="button"
                                    :class="['btn btn-block btn-primary px-4' , form.loading || loading ? 'btn-loading' : '']"
                                    @click="check('init')">
                                Check phone number
                            </button>
                        </div>

                        <div v-else class="d-flex flex-row text-center mt-3">
                            <button type="button"
                                    :class="['btn btn-sm btn-primary mr-1 col-6' , form.loading || loading ? 'btn-loading' : '']"
                                    @click="verify">
                                Verify
                            </button>
                            <button type="button"
                                    :disabled="isResendDisabled"
                                    :class="['btn btn-sm btn-danger bg-accent ml-1 col-6' , form.loading || loading ? 'btn-loading' : '']"
                                    @click="check('resend')">
                                Resend <small v-if="countdown"> ({{ countdown }} sec)</small>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </transition>

        <transition name="slide-in-left">
            <div v-if="verified">
                <h5 class="text-left font-weight-500 text-2">
                    Step 2: Register with Moovah
                </h5>
                <div v-if="!registered">
                    <p class="text-1">
                        Complete your registration to proceed with your vehicle insurance and licensing.
                    </p>
                    <div class="form-group">
                        <label>Email</label>
                        <input type="text" class="form-control" v-model="form.email"/>
                        <div v-text="form.errors.get('email')" class="text-danger"/>
                    </div>
                    <div class="form-group">
                        <label>First Name</label>
                        <input type="text" class="form-control" v-model="form.name"/>
                        <div v-text="form.errors.get('name')" class="text-danger"/>
                    </div>
                    <div class="form-group">
                        <label>Last Name</label>
                        <input type="text" class="form-control" v-model="form.last_name"/>
                        <div v-text="form.errors.get('last_name')" class="text-danger"/>
                    </div>
                    <div class="form-group">
                        <label>Date of Birth</label>
                        <input type="date" class="form-control" v-model="form.dob"/>
                        <div v-text="form.errors.get('dob')" class="text-danger"/>
                    </div>
                    <div class="form-group">
                        <label>Gender</label>
                        <select type="text" class="form-control" v-model="form.gender">
                            <option value="">Choose Gender</option>
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                        </select>
                        <div v-text="form.errors.get('gender')" class="text-danger"/>
                    </div>
                    <div class="form-group">
                        <label>National ID</label>
                        <input type="text" class="form-control" v-model="form.national_id"/>
                        <div v-text="form.errors.get('national_id')" class="text-danger"/>
                    </div>
                    <div class="form-group">
                        <label>Town</label>
                        <input type="text" class="form-control" v-model="form.town"/>
                        <div v-text="form.errors.get('town')" class="text-danger"/>
                    </div>
                    <div class="form-group">
                        <label>Province</label>
                        <input type="text" class="form-control" v-model="form.province"/>
                        <div v-text="form.errors.get('province')" class="text-danger"/>
                    </div>
                    <div class="text-center mt-3">
                        <button type="button"
                                :class="['btn btn-block btn-primary px-4' , form.loading || loading ? 'btn-loading' : '']"
                                @click.prevent="register">
                            Register
                        </button>
                    </div>
                </div>
                <div v-if="registered">
                    <div class="bg-light text-center text-white py-4 mb-3">
                        <check-mark class="p-6"></check-mark>
                        <h5 class="text-3">You are already registered.</h5>
                    </div>
                    <button type="button"
                            :class="['btn btn-block btn-primary px-4 btn-loading']"
                            >
                    </button>
                </div>

            </div>
        </transition>

    </form>
</template>

<script>
import Form from "../../../core/forms/form";
import {validity} from "../../../core/forms/validity";
import PhoneInput from "../../custom/phone-input";
import {appDataMixin} from "../../../core/data/global";
import {f} from "vue-phone-number-input";
import CheckMark from "../../core/Checkmark.vue";

export default {
    name: "ZinaraRegister",
    components: {PhoneInput,CheckMark},
    mixins: [validity, appDataMixin],
    data: function () {
        return {
            loading: false,
            fields: [
                'phone'
            ],
            message: null,
            otp: false,
            registered: false,
            countdown: null,
            resendTimerId: null,
            currentStep: 0,
            initialCountdownValue: 30,
            showStart: true,
            nextStep: null,
            verified: false,
            form: new Form({
                otp: '',
                phone: '',
                email: '',
                name: '',
                last_name: '',
                gender: '',
                national_id: '',
                dob: '',
                town: '',
                province: '',
                id: '',
            })
        };
    },

    watch: {},

    methods: {
        toggleShowStart() {
            this.showStart = !this.showStart;
            this.scrollToTop();
            this.completeStep();
        },
        startCountdown() {
            if (!this.resendTimerId) {
                this.countdown = this.initialCountdownValue;
                this.resendTimerId = setInterval(() => {
                    if (this.countdown > 0) {
                        this.countdown--;
                    }
                    else {
                        clearInterval(this.resendTimerId);
                        this.countdown = null;
                        this.resendTimerId = null;
                    }
                }, 1000);
            }
        },

        saveToLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                localStorage.setItem(this.fields[i], this.form[this.fields[i]]);
            }
        },

        getFromLocalStorage() {
            for (let i = 0; i < this.fields.length; i++) {
                let value = localStorage.getItem(this.fields[i]);
                if (value != null && value !== "" && value !== "null") {
                    this.form[this.fields[i]] = value;
                }
            }
        },

        check(stage) {
            this.startCountdown();
            this.saveToLocalStorage();
            this.form.submit('/zinara/register/phone').then((response) => {
                this.form.id = response.data.body.id;
                this.message = response.data.message;
                this.registered = response.data.body.status;
                this.otp = response.data.body.otp;
                if (stage === 'init') {
                    this.completeStep();
                }
            });

        },

        verify(event) {

            event.preventDefault();
            this.saveToLocalStorage();
            this.form.submit('/zinara/register/verify').then((response) => {
                this.message = response.data.message;
                setTimeout(() => {
                    this.message = null;
                }, 3000);
                this.verified = true;
                this.showStart = null;
                this.completeStep();
                if(this.registered === true) {
                    setTimeout(function () {
                        this.$router.push(`/zinara/vehicles?id=${this.form.id}`);
                    }.bind(this), 3000);
                }
            });
        },

        register(event) {

            event.preventDefault();
            this.saveToLocalStorage();
            this.form.submit('/zinara/register').then((response) => {
                this.completeStep();
                this.$router.push(`/zinara/vehicles/create?id=${response.data.body.id}`);
            });

        },
        completeStep() {
            if (this.currentStep < 3) {
                this.currentStep += 0.75;
            }
        }

    },computed: {
        stepProgress() {
            return (this.currentStep / 3) * 100;
        },
        isResendDisabled: function(){
            return this.countdown !== null;
        }
    },

    mounted() {
    }
}
</script>
<style scoped>
.form-control.is-invalid,
.was-validated .form-control:invalid {
    border-color: #dc3545;
   border-radius: 0;
}
.checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #7ac142;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards
}

.checkmark {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px #7ac142;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both
}

.checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0
    }
}

@keyframes scale {
    0%,
    100% {
        transform: none
    }
    50% {
        transform: scale3d(1.1, 1.1, 1)
    }
}

@keyframes fill {
    100% {
        box-shadow: inset 0px 0px 0px 30px #7ac142
    }
}
</style>
